export default __webpack_public_path__ + "static/media/ic_argentina.a59e0635.svg";